import styled from "styled-components"

import ButtonCss from "@irati/ui/src/Button/styled"

import RouterLink from "../../RouterLink"

export const ButtonRouterLinkUI = styled(RouterLink)`
  ${ButtonCss}

  position: relative;
  text-transform: none;

  .loader {
    position: absolute;
    margin: 0;
  }
`

interface ChildWrapperProps {
  processing?: boolean
}
export const ChildWrapper = styled.div<ChildWrapperProps>`
  visibility: ${({processing}) => (processing ? "hidden" : "visible")};
`
